import styles from './excursions.module.css';

import get from 'lodash/get';
import { GetServerSideProps } from 'next';
import { useEffect } from 'react';

import { PageContextOptions } from 'core/services/context';
import { CommonPageContext } from 'core/services/context/context';
import { getQueryParamsWithUrl } from 'core/utils/filters/search-filter';
import { getPageContextWithAuth } from 'core/utils/get-page-context-with-auth';

import { Text } from 'components/common/text/text';
import { Page } from 'components/page/page';

interface PromoCodePageProps {
  context: {
    common: CommonPageContext;
  };
}

interface AtomSIFrameOptions {
  host: string;
  partner: string;
  partner_type: string;
}

interface AtomSIFrameType {
  initialization: (id: string, options: AtomSIFrameOptions) => void;
}

const ATOM_FRAME_ID = 'atomFrame';
const settings = {
  iframeScript: 'https://excurs.nevaseasons.ru/media/com_jatoms/js/iframe.min.js',
  host: 'https://excurs.nevaseasons.ru/tury-po-sankt-peterburgu',
  partner: '658285a3-2f7a-4af4-9083-8d89fa3e62f5',
  type: 'marketplace'
};

const ExcursionsSpb = (props: PromoCodePageProps) => {
  useEffect(() => {
    const atomSIFrame = get(window, 'AtomSIFrame', null) as Optional<AtomSIFrameType>;
    if (atomSIFrame) {
      atomSIFrame.initialization(ATOM_FRAME_ID, {
        host: settings.host,
        partner: settings.partner,
        partner_type: settings.type
      });
    }
  }, []);

  return (
    <Page
      ctx={{
        ...props.context.common,
        seo: {
          ...props.context.common.seo,
          title: 'Экскурсии в Санкт-Петербурге, Петергофе, Выборге',
          description: 'Обзорные экскурсии по Санкт-Петербургу и соседним городам: мосты, дворцы, музеи'
        }
      }}
      hasSearchBar
    >
      <>
        <Text className={styles.title} As='h1' size={28} desktopSize={36}>
          Экскурсии в&nbsp;Санкт-Петербурге
        </Text>
        <Text As='p' size={16}>
          Все экскурсии предоставлены нашим партнером, туристической компанией &laquo;Невский сезоны&raquo;.
        </Text>
        <div className={styles.frame} id={ATOM_FRAME_ID} />
        <script src={settings.iframeScript} />
      </>
    </Page>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res } = context;
  const mainHost = process.env.NEXT_PUBLIC_MAIN_HOST || '';
  const correlationID = get(context, 'req.headers.x-request-id', '') as string;
  const cookies = get(context, 'req.headers.cookie', '');
  const accept = get(context, 'req.headers.accept', '');
  const query = getQueryParamsWithUrl(context);

  const options: PageContextOptions<CommonPageContext> = {
    path: '/',
    host: mainHost,
    correlationID,
    cookies,
    authRequired: false,
    query,
    accept
  };

  const host: string = get(context, 'req.headers.host', '');

  const pageContext = await getPageContextWithAuth(host, options);

  if (pageContext) {
    if (pageContext?.props?.context?.common['set-cookie']) {
      pageContext.props.context.common['set-cookie'].map((cookie) => {
        res.setHeader('Set-Cookie', cookie);
      });
    }
  }

  return pageContext;
};

export default ExcursionsSpb;
